import { getOrders, getOrderDetails } from '@/requests/kariRequests'

const state = {
  instArr: [],
  instArrHistory: [],
  selectedInst: {}
};

const getters = {};

const actions = {
  /**
   *  текущие рассрочки пользователя
   */
  async getInstallments ({ commit, dispatch }) {
    const result = await getOrders()
    console.log(result);
    if (Array.isArray(result)) {
      commit('saveInstallments', result);
      return true;
    } else {
      console.log(result);
      // alert(result.errorMessage);
      return false;
    }
  },
  async getInstDetail ({ commit, dispatch }, data) {
    // console.log('getInstDetail');
    // console.log('данные' + ' ' + data);
    // console.log('массив рассрочек, куда стучимся' + ' ' + data.target)
    // console.log(state[data.target])
    const indexOrder = state[data.target].findIndex((item) => {
      // console.log('поищем нужную рассрочку');
      // console.log('гуид из хранилища' + ' ' + item.guid);
      // console.log('наш гуид' + ' ' + data.guid);
      // console.log('сходятся?' + ' ' + (item.guid === data.guid));
      return item.guid === data.guid;
    });
    // console.log('найденный индекс элемента в массиве -' + ' ' + indexOrder)
    if (indexOrder >= 0) {
      // console.log('>=0')
      const orderIdentifier = state[data.target][indexOrder].guid;
      // console.log(state[data.target][indexOrder].paymentPlan.length);
      // if (state.instArr[indexOrder].paymentPlan.length === 0) { старое условие;
      // console.log('длина графика платежей' + ' ' + state[data.target][indexOrder].paymentPlan.length)
      if (state[data.target][indexOrder].paymentPlan.length === 0 || data.reloadGraphic) {
        // console.log('начнём расчёт графика')
        /**
         * детальная информация по договору от бэк
         * @type {{cart:object,paymentPlan:array,payments:array}}
         */
        const result = await getOrderDetails(orderIdentifier);
        // todo если словили 500, то надо че нить придумать
        try {
          dispatch('calculatePaymentPlan', {
            target: data.target,
            indexElement: indexOrder,
            paymentPlan: result.paymentPlan,
            payments: result.payments,
            cart_items: result.cart?.cart_items
          });
          return true;
        } catch (error) {
          console.log(error);
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  },
  /**
   * проводит расчет статуса графика, основываясь на данных по фактическим платежам
   * @param commit
   * @param detailInstalment {{indexElement: string, paymentPlan: Array, payments: Array, cart_items: Array, nextPayment: object, sumFromClient: number}}
   */
  calculatePaymentPlan: ({ commit }, detailInstalment) => {
    // console.log(detailInstalment);
    /**
     * сумма платежей клиента * 100
     * @type {number}
     */
    let sumFromClient = 0;
    /**
     * счетчик не оплаченных пунктов графика
     * @type {number}
     */
    let canPayButton = 0;
    // проверяем, что объекты существуют
    if (detailInstalment.paymentPlan !== undefined && Array.isArray(detailInstalment.paymentPlan)) {
      // считаем сколько занес клиент в кассу
      for (let i = 0; i <= detailInstalment.payments.length - 1; i += 1) {
        sumFromClient += detailInstalment.payments[i].sum * 100;
      }
      // console.log('все платежи', detailInstalment.payments);
      // console.log('сумма платежей', sumFromClient);
      // бежим по графику, смотрим что есть растопляем метки оплачено или нет
      for (let i = 0; i <= detailInstalment.paymentPlan.length - 1; i += 1) {
        // console.group(detailInstalment.paymentPlan[i].stage);
        // насчитаем сколько уже должен был внести клиент на текущем этапе * 100
        detailInstalment.paymentPlan[i].sumPaymentPlan = (i === 0)
          ? detailInstalment.paymentPlan[i].sum * 100
          : detailInstalment.paymentPlan[i - 1].sumPaymentPlan + (detailInstalment.paymentPlan[i].sum * 100);
        // console.log(detailInstalment.paymentPlan[i].sumPaymentPlan);
        // console.log(sumFromClient);
        if (detailInstalment.paymentPlan[i].sumPaymentPlan <= sumFromClient) {
          // клиент внес достаточно денег, что бы закрыть этот этап
          detailInstalment.paymentPlan[i].calcPaymentStatus = 'оплачен';
        } else {
          // клиент не внес достаточно денег, что бы закрыть этот этап
          detailInstalment.paymentPlan[i].calcPaymentStatus = 'не оплачен';
          // если по счетчику это первый раз, то ставим отметку сколько нужно внести что бы закрыть этот платеж, все последующие этапы графика игнорируем
          // console.log(detailInstalment.paymentPlan[i].sumPaymentPlan)
          // console.log(sumFromClient)
          detailInstalment.paymentPlan[i].payForClose = (canPayButton === 0)
            ? detailInstalment.paymentPlan[i].sumPaymentPlan - sumFromClient
            : 0;
          // console.log(detailInstalment.paymentPlan[i].payForClose)
          canPayButton += 1;
          // отдельно сохраняем информацию о текущем платеже, не учитывает если последующие тоже в просрочке
          // console.log('canPayButton', canPayButton);
          if (canPayButton === 1) {
            const currentDateObj = new Date();
            const dd = (currentDateObj.getDate() < 10) ? '0' + currentDateObj.getDate() : currentDateObj.getDate();
            const mm = ((currentDateObj.getMonth() + 1) < 10) ? '0' + (currentDateObj.getMonth() + 1) : (currentDateObj.getMonth() + 1);
            const yyyy = currentDateObj.getFullYear();
            const curDateStr = `${yyyy}-${mm}-${dd}`;
            // console.log('curDateStr', curDateStr);
            // console.log('detailInstalment.paymentPlan[i].date', detailInstalment.paymentPlan[i].date);
            detailInstalment.nextPayment = {
              date: detailInstalment.paymentPlan[i].date,
              sum: detailInstalment.paymentPlan[i].payForClose,
              msg: curDateStr > detailInstalment.paymentPlan[i].date ? 'Задолженность по платежу' : 'Ближайший платёж'
            };
          }
        }
        // console.log(detailInstalment.paymentPlan[i]);
        // console.groupEnd(detailInstalment.paymentPlan[i].stage);
      }
      detailInstalment.sumFromClient = sumFromClient;
      commit('saveDetailInstallmentData', detailInstalment);
    } else {
      return false;
    }
  }
};

const mutations = {
  setSelectedInst: (state, value) => {
    state.selectedInst = value
  },
  saveInstallments: (state, data) => {
    const filteredData = []
    const filteredHistoryData = []
    for (let i = 0; i < data.length; i++) {
      data[i].paymentPlan = [];
      data[i].payments = [];
      data[i].cart_items = [];
      data[i].sumFromClient = 0;
      data[i].nextPayment = {
        date: '',
        sum: 0,
        msg: ''
      };
      //       статусы могут быть:
      //       активные:
      //       CREATED
      //       PARTIALLY_CANCELED
      //       PARTIALLY_ISSUED
      //       ISSUED
      //       PARTIALLY_RETURNED
      //       закрытые, помещаемые в историю:
      //       CANCELED
      //       RETURNED
      //       PAID
      if (data[i].status === 'CREATED' || data[i].status === 'ISSUED' || data[i].status === 'PARTIALLY_ISSUED' || data[i].status === 'PARTIALLY_CANCELED' || data[i].status === 'PARTIALLY_RETURNED') {
        filteredData.push(data[i]);
      } else {
        filteredHistoryData.push(data[i]);
      }
    }
    state.instArr = filteredData;
    state.instArrHistory = filteredHistoryData;
  },
  saveDetailInstallmentData: (state, data) => {
    if (data.paymentPlan !== undefined) {
      state[data.target][data.indexElement].paymentPlan = data.paymentPlan;
    }
    if (data.payments !== undefined) {
      state[data.target][data.indexElement].payments = data.payments;
    }
    if (data.cart_items !== undefined) {
      state[data.target][data.indexElement].cart_items = data.cart_items;
    }
    if (data.nextPayment !== undefined) {
      state[data.target][data.indexElement].nextPayment = data.nextPayment;
    }
    if (data.sumFromClient !== undefined) {
      state[data.target][data.indexElement].sumFromClient = data.sumFromClient;
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
